if (!customElements.get('tcl-product-compare')) {
  customElements.define('tcl-product-compare', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const buttons = [...this.querySelectorAll('[data-size-button]')];
      const cards = [...this.querySelectorAll('[data-model-card]')];
      cards.forEach(card => {
        card.dataset.productUrl = card.querySelector('[data-card-action]').getAttribute('href');
      });
      const selectSize = size => {
        if (!buttons.some(button => button.dataset.sizeButton === size)) return;
        buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.sizeButton === size)));
        this.querySelectorAll('[data-selected-size]').forEach(node => { node.textContent = `${size}-inch`; });
        this.querySelectorAll('[data-variant-price-size]').forEach(node => {
          node.hidden = node.dataset.variantPriceSize !== size;
        });
        cards.forEach(card => {
          const model = card.dataset.modelCard;
          const price = card.querySelector(`[data-variant-price-size="${size}"]`);
          const exists = price?.dataset.sizeExists === 'true';
          card.classList.toggle('unavailable', !exists);
          card.querySelector('[data-card-price-label]').textContent = exists ? `${size}-inch price` : 'Size availability';
          const action = card.querySelector('[data-card-action]');
          action.setAttribute('href', model === this.dataset.currentModel ? '#product_box' : exists ? price.dataset.variantUrl : card.dataset.productUrl);
          action.textContent = 'SHOP NOW';
        });
        const status = this.querySelector('[data-size-status]');
        if (status) status.textContent = `Showing ${size}-inch model comparison.`;
      };
      buttons.forEach(button => button.addEventListener('click', () => selectSize(button.dataset.sizeButton)));
      selectSize(this.dataset.initialSize || '75');
      const upgradeTabs = [...this.querySelectorAll('[data-upgrade-tab]')];
      const upgradePanels = [...this.querySelectorAll('[data-upgrade-panel]')];
      const selectUpgrade = (model, focus = false) => {
        if (!upgradeTabs.some(tab => tab.dataset.upgradeTab === model)) return;
        upgradeTabs.forEach(tab => {
          const selected = tab.dataset.upgradeTab === model;
          tab.setAttribute('aria-selected', String(selected));
          tab.tabIndex = selected ? 0 : -1;
          if (selected && focus) tab.focus();
        });
        upgradePanels.forEach(panel => {
          panel.hidden = panel.dataset.upgradePanel !== model;
        });
      };
      upgradeTabs.forEach((tab, index) => {
        tab.addEventListener('click', () => selectUpgrade(tab.dataset.upgradeTab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % upgradeTabs.length;
          else if (event.key === 'ArrowLeft') next = (index + upgradeTabs.length - 1) % upgradeTabs.length;
          else if (event.key === 'Home') next = 0;
          else if (event.key === 'End') next = upgradeTabs.length - 1;
          else return;
          event.preventDefault();
          selectUpgrade(upgradeTabs[next].dataset.upgradeTab, true);
        });
      });
      const selectedUpgrade = upgradeTabs.find(tab => tab.getAttribute('aria-selected') === 'true') || upgradeTabs[0];
      if (selectedUpgrade) selectUpgrade(selectedUpgrade.dataset.upgradeTab);
    }
  });
}
